export interface EvidenceSource {
  id: string; kind: string; label: string; observed_at: string | null; age_seconds?: number;
  href: string; data: Record<string, any>;
}
export interface EvidenceSnapshot {
  version: number; as_of: string; topic: string; hours: number; instruments: string[];
  scope?: { companies: string[]; contracts: string[]; korea: boolean };
  search_terms: string[]; sources: EvidenceSource[]; limits: string[];
  news_source_health?: { state: string; last_collected_at?: string | null; recent_articles?: number };
  sections: Record<string, { available: boolean; rows: Record<string, any>[] | null; collection?: Record<string, any>; intraday?: { available?: boolean; rows?: Record<string, any>[]; collection?: Record<string, any> }; error: string | null }>;
}
export interface EvidencePoint { text: string; source_ids: string[] }
export interface HorizonMemo {
  thesis: string; supporting: EvidencePoint[]; opposing: EvidencePoint[];
  catalysts: EvidencePoint[]; confirm: EvidencePoint[]; invalidate: EvidencePoint[];
}
export interface DecisionMemo {
  title: string; summary: string; investment: HorizonMemo | null;
  trading: HorizonMemo | null; missing_data: string[];
}
export interface PersonalAnalysis {
  topic: string; question: string; horizon: string; call_id: string; request_id: string;
  generated_at: string; model: string; outcome: string; report: DecisionMemo | null;
  snapshot: EvidenceSnapshot; cost_usd: number; tokens: number; saved: boolean;
  attempts: { call_id: string; status: string }[];
  raw_response?: string;
  diagnostics?: { code: string; path: string; message: string; original?: unknown }[];
  question_feedback?: string[];
  saved_outcome?: string;
}
export interface AnalysisHistoryItem {
  call_id: string; ts: string; model: string; topic: string; horizon: string;
  outcome: string; title: string | null; cost_usd: number;
}
export const KIND_LABELS: Record<string, string> = {
  toss_research: '토스 시장·연구 근거',
  news: '뉴스', prices: '가격', funding: '펀딩', calendar: '경제 일정',
  company_metrics: '기업·옵션 지표', supply_demand: '국내 수급', news_coverage: '뉴스 분석 상태', technical: '과열·추세 지표', korea_equities: '삼성·하이닉스', macro_context: '환율·미 국채·유가',
};
export const METRIC_LABELS: Record<string, string> = {
  week52_high: '52주 고점', week52_low: '52주 저점', week52_current: '52주 범위 현재가',
  put_call_ratio_oi: '풋/콜 미결제 비율', max_pain: '옵션 최대 고통 가격', gamma_flip: '감마 전환 가격',
  options_reference_price: '옵션 기준 기초가격', options_volume_current_ratio: '옵션 거래량 비율',
  regular_price: '정규장 기초가격', day_high: '당일 고점', day_low: '당일 저점',
  days_to_cover: '공매도 커버 일수', analyst_count: '애널리스트 수',
  net_gamma_exposure: '순 감마 노출', volume_days_counted: '거래량 비교 표본 일수',
  price: '기초자산 가격', regular_change_pct: '정규장 변화', per: 'PER', roe: 'ROE',
  revenue_yoy_latest: '최근 매출 전년 대비', analyst_upside_pct: '애널리스트 목표가 괴리',
  short_interest_pct: '공매도 비율', put_call_ratio_volume: '풋/콜 거래량 비율',
  put_wall: '풋 월', call_wall: '콜 월', options_days_to_expiry: '옵션 만기까지 일수',
  volume_current_ratio: '거래량 비율',
};
export { runAnalysisJob } from './llmJobs';
import { runAnalysisJob } from './llmJobs';
export async function createPersonalAnalysis(body: Record<string, unknown>, options: { resume?: boolean; signal?: AbortSignal } = {}): Promise<PersonalAnalysis> {
  return runAnalysisJob<PersonalAnalysis>('personal', body, options);
}
